import React from 'react'
import TrackableButton from 'src/viewLayer/components/shared/TrackableButton'
import { t } from 'src/viewLayer/helpers/translations'

import { useBusinessPagePath } from '../../../navigation'

export default () => (
  <TrackableButton
    color="secondary"
    href={useBusinessPagePath()}
    id="uat-business-button"
    trackingId="login_b2b_sso"
  >
    {t('login_options.button.b2b.company_email')}
  </TrackableButton>
)
